
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_ig8mp_1betj_193",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_ig8mp_1betj_1",
  "tutorial-list": "awsui_tutorial-list_ig8mp_1betj_215",
  "tutorial-box": "awsui_tutorial-box_ig8mp_1betj_251",
  "tutorial-box-title": "awsui_tutorial-box-title_ig8mp_1betj_295",
  "tutorial-description-plaintext": "awsui_tutorial-description-plaintext_ig8mp_1betj_301",
  "tutorial-description": "awsui_tutorial-description_ig8mp_1betj_301",
  "expandable-section": "awsui_expandable-section_ig8mp_1betj_312",
  "expanded": "awsui_expanded_ig8mp_1betj_316",
  "button-wrapper": "awsui_button-wrapper_ig8mp_1betj_320",
  "start": "awsui_start_ig8mp_1betj_325",
  "expand-button": "awsui_expand-button_ig8mp_1betj_329",
  "collapse-button": "awsui_collapse-button_ig8mp_1betj_333",
  "learn-more-link": "awsui_learn-more-link_ig8mp_1betj_337",
  "title": "awsui_title_ig8mp_1betj_341",
  "prerequisites-alert": "awsui_prerequisites-alert_ig8mp_1betj_345",
  "completed": "awsui_completed_ig8mp_1betj_349",
  "download-link": "awsui_download-link_ig8mp_1betj_353"
};
  